"use strict"

export class EventMessenger {
    static __instance = null;
    static get instance() {
        if (EventMessenger.__instance == null) {
            EventMessenger.__instance = new EventMessenger();
        }
        return EventMessenger.__instance;
    }

    constructor() {
        this.__events = [];
    }

    __connect(key,callback) {
        if (!this.__validateCallback(callback)) return;
        const index = this.__getIndex(key);
        if (index == -1) {
            this.__events.push({
                key: key,
                connections: [callback]
            });
            return;
        }
        this.__events[index].connections.push(callback);
    }
    __disconnect(key,callback) {
        if (!this.__validateCallback(callback)) return;
        const index = this.__getIndex(key);
        if (index == -1) return;
        const callbackIndex = this.__getConnectionIndex(this.__events[index], callback);
        if (callbackIndex == -1) return;
        this.__events[index].connections.splice(callbackIndex, 1);
        if (this.__events[index].connections.length == 0) {
            this.__events.splice(index, 1);
        }
    }

    __trigger(key,data) {
        const index = this.__getIndex(key);
        if (index == -1) return;
        this.__events[index].connections.forEach(c => c(data));
    }
    __returnTrigger(key,data) {
        const index = this.__getIndex(key);
        if (index == -1) return;
        if (this.__events[index].connections.length == 0) return;
        return this.__events[index].connections[0](data);
    }

    __validateCallback(callback) {
        return typeof callback == "function";
    }
    __getIndex(key) {
        return this.__events.findIndex(x => x.key == key);
    }
    __getConnectionIndex(event,connection) {
        return event.connections.findIndex(x => x == connection);
    }

    static connect(key,callback) {
        EventMessenger.instance.__connect(key, callback);
    }

    static disconnect(key,callback) {
        EventMessenger.instance.__disconnect(key, callback);
    }

    static trigger(key,data) {
        EventMessenger.instance.__trigger(key, data);
    }
    static returnTrigger(key,data) {
        return EventMessenger.instance.__returnTrigger(key, data);
    }
}